// Get the button (main div, not the link)
var mybutton = document.getElementById("scrollToTop");

// Initially hide the button (already hidden by CSS)
mybutton.style.display = "none";

// When the user scrolls down 100px from the top of the document, show the button
window.onscroll = function() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        mybutton.style.display = "flex"; // Show the entire button circle
    } else {
        mybutton.style.display = "none"; // Hide the entire button circle
    }
};

// When the  userclicks on the button, scroll to the top of the document
mybutton.onclick = function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};